import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sammanslagen med elavtalssidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/fast")({
  beforeLoad: () => {
    throw redirect({ to: "/elavtal/fast", statusCode: 301 });
  },
});
